declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';




declare var require: any;


import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { BillDetailsInfoController, x_BillDetailsRequest, X_BillHeaderController, X_BillItemsController, X_BillReceiptsController, PurchaseIndentsListController, PurchaseIndentsListRequest, PurchaseIndentItemsController, PurchaseIndentItemsRequest, PurchaseIndentItemsInfoController } from '../../../models/actor/actor';
import { AppData } from '../../../models/appdata';
import { ActorService } from '../../../services/actor.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { ApiResponseModel } from '../../../models/api_response_model';
import { SpinnerService } from '../../../services/spinner.service';
//import { billingpipe } from '../../../pipes/actors/actorIdentity.pipes';
//import { Pipe } from '@angular/core';
//import { Injectable } from '@angular/core';
//import { PipeTransform } from '@angular/core';
import { BillingPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbPaymentModeChangeModal } from './modal/paymentmodechange.modal';



@Component({
  selector: 'purchaseindent',
  templateUrl: './purchaseindent.component.html',
  styleUrls: [
    './purchaseindent.component.scss']
  , animations: [routerTransition()]
})

export class PurchaseIndentComponent implements OnInit {



  public ApiResData: ApiResponseModel;
  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public Showrow: boolean = true;
  public SelectedFormattedCode: string;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public billdetails1: boolean = false;
  public ChargeEntryCode: number;
  public billdetails2: boolean = false;
  public PatientName: string;
  public PayeeName: string;
  public Toatalbill: number;
  public PaidBill: number;
  public searchValue: string;
  public DiscountMode: string;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  SelectedFromDate: NgbDateStruct;

  CurrentPurchaseIndentsListController: PurchaseIndentsListController[];
  CurrentPurchaseIndentsHeaderController: PurchaseIndentsListController;
  CurrentPurchaseIndentsListRequest: PurchaseIndentsListRequest;

  LoadIndents() {
    this.CurrentPurchaseIndentsListRequest = new PurchaseIndentsListRequest();
    this.CurrentPurchaseIndentsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentPurchaseIndentsListController;
    this.GetPurchaseIndentsListController();
  }
  GetPurchaseIndentsListController() {
    this.StartRefreshing();
    this.CurrentPurchaseIndentsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentPurchaseIndentsListRequest.FromDate = new Date();
    this.CurrentPurchaseIndentsListRequest.ToDate = new Date();
    //this.CurrentPurchaseIndentsListRequest.PurchaseIndentCode = 0;
    this.CurrentPurchaseIndentsListRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseIndentsListController(this.CurrentPurchaseIndentsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPurchaseIndentsListController = this.ApiResData.Result;
          //this.pdata = this.CurrentPurchaseIndentsListControllernew;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentPurchaseIndentItemsController: PurchaseIndentItemsController[];
  CurrentPurchaseIndentItemsRequest: PurchaseIndentItemsRequest;
  PurchaseIndentDataHeader: PurchaseIndentItemsInfoController;

  LoadItems() {
    this.CurrentPurchaseIndentItemsRequest = new PurchaseIndentItemsRequest();
    this.CurrentPurchaseIndentItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetPurchaseIndentItemsController();
  }
  GetPurchaseIndentItemsController() {
    this.StartRefreshing();
    this.CurrentPurchaseIndentItemsRequest.DOCID = this.SelectedpatientDetails.DocID;
    this.CurrentPurchaseIndentItemsRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseIndentItemsController(this.CurrentPurchaseIndentItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPurchaseIndentItemsController = this.ApiResData.Result;
          this.PurchaseIndentDataHeader = this.ApiResData.Result; 
          this.CurrentPurchaseIndentItemsController = this.PurchaseIndentDataHeader.PurchaseItems;
          this.CurrentPurchaseIndentsHeaderController = this.PurchaseIndentDataHeader.PurchaseHeader;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    public printService: PrintService,
    private modalService: NgbModal,
    private actorservice: ActorService,
    private route: ActivatedRoute,
    private loaderService: SpinnerService,
    private parserFormatter: NgbDateParserFormatter,
    private filter: BillingPipe

    ,
  ) { }

  ngOnInit() {
    this.LoadIndents();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    
  }



  ShowList: boolean = true;

  SelectedpatientDetails: PurchaseIndentsListController;
  Selectedpatient(objCategory: any) {
    var patient: PurchaseIndentsListController = objCategory;
    if (patient != null) {
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = patient;
      this.billdetails1 = true;
      //this.billdetails2 = true;
      this.LoadItems();
    }


  }
 //Selectedpatient() {


 //   this.billdetails1 = true;
 //   this.billdetails2 = true;

 // }
  dataChanged(newobj) {

    this._GetPurchaseIndentsListController()
  }
  _GetPurchaseIndentsListController() {
    this.StartRefreshing();
    this.CurrentPurchaseIndentsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentPurchaseIndentsListRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentPurchaseIndentsListRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //this.CurrentPurchaseIndentsListRequest.PurchaseIndentCode = 0;
    this.CurrentPurchaseIndentsListRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseIndentsListController(this.CurrentPurchaseIndentsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPurchaseIndentsListController = this.ApiResData.Result;
          //this.pdata = this.CurrentPurchaseIndentsListControllernew;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetPurchaseIndentsListController();
  }
  IncrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetPurchaseIndentsListController();
  }
  //pdata: any[];
  //listFilter: string;
  //ngOnChanges(changes: any) {
  //  if (JSON.stringify(changes).indexOf("data") != -1)
  //    this.pdata = this.CurrentPurchaseIndentsListControllernew;

  //  this.criteriaChange(this.listFilter);
  //}
  //criteriaChange(value: any) {
  //  if (this.filter != null) {
  //    if (value != '[object Event]') {
  //      this.listFilter = value;
  //      this.pdata = this.filter.transform(this.CurrentPurchaseIndentsListControllernew,
  //        this.listFilter);
  //    }
  //  }
  //}
  AddIndent() {
    this.router.navigate(['healins/indentadd']);
  }
  //Indentedit() {
  //  this.router.navigate(['healins/indentedit', {
  //    DocIDData: this.SelectedpatientDetails.DocID
  //  }]);
  //}

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  header() {
    let m = document.querySelector("#header");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  items() {
    let m = document.querySelector("#items");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Receipts() {
    let m = document.querySelector("#Receipts");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  billedit() {
    //alert("hello2");
    this.router.navigate(['healins/invoicereceipt']);
  }

  opbill() {

  }
  A5opbill() {

  }
}
